import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { fetchAsyncGetClientByID } from "redux/clientProjectSlice";

const useClientDetails = (clientId) => {
    const [clientDetail, setClientDetail] = useState({});
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const { addToast } = useToasts();
    useEffect(() => {
      const fetchClientDetails = async () => {
        setLoading(true);
        try {
          const res = await dispatch(fetchAsyncGetClientByID(clientId));
          if (res?.payload) {
            setClientDetail(res.payload.client);
          }
        } catch (error) {
          addToast(`Error fetching client details:`, { appearance: "error" });
        } finally {
          setLoading(false);
        }
      };
      if (clientId) {
        fetchClientDetails();
      }
    }, [clientId, dispatch, addToast]);
    return {clientDetail, loading};
  };
  export default useClientDetails;